import { useForm } from "../../hooks/useForm";
import {
  useLazyValidarSesionQuery,
  useLoginMutation,
  useValidarSesionQuery,
} from "../../services/docs";
import { useNavigate } from "react-router-dom";
import fondo from "../../assets/img/fondo_1.jpg";

import { useRef, useState, useEffect, JSX } from "react";
import { useDispatch } from "react-redux";
import { agregarToken, iniciarSesion } from "../../features/ui/uiSlice";
import { toastr } from "react-redux-toastr";
import { Spinner } from "../../components/Spinner";
import { FaRegUser, FaRegEyeSlash } from "react-icons/fa";

export const LoginScreen = (): JSX.Element => {
  const [IsPin, setIsPin] = useState(false);
  const [pin, setPin] = useState(["", "", "", "", "", ""]);
  const inputRefs = useRef([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loginSend, { isLoading, error, isSuccess, reset }] =
    useLoginMutation();
  const {
    formulario,
    handleInputChange,
    handleChange: hc,
  } = useForm({
    password: "",
    username: "",
    pin: "",
  });
  const { password, username } = formulario;

  const handleChange = (e, index) => {
    const { value } = e.target;
    if (/^[0-9]$/.test(value) || value === "") {
      const newPin = [...pin];
      newPin[index] = value;
      setPin(newPin);
      if (value !== "" && index < 5) {
        inputRefs.current[index + 1].focus();
      }
    }
  };
  useEffect(() => {
    if (IsPin) {
      hc("pin", pin.join(""));
    }
  }, [pin]);

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && pin[index] === "" && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text").slice(0, 6);
    if (/^\d{6}$/.test(pasteData)) {
      const newPin = pasteData.split("");
      setPin(newPin);
      inputRefs.current[3].focus();
    }
  };

  const handleLogin = async (e: any) => {
    e.preventDefault();
    const resp = await loginSend({ ...formulario })
      .unwrap()
      .catch((err: any) => {
        if (err.status === 400) {
          if (err.data.message) {
            if (Array.isArray(err.data.message)) {
              err.data.message.map((m: any) => {
                toastr.error(m);
              });
            } else {
              toastr.error(err.data.message);
            }
          }
          if (err.data.restablecer === 1) {
            navigate("/auth/expire", { replace: true });
          }
        } else {
          toastr.error(err.data.message);
        }
      });
    if (resp) {
      if (resp.pin === 1) {
        toastr.info(resp.message);
        setIsPin(true);
        return;
      }
      dispatch(agregarToken({
        token: resp.token,
        refreshToken: resp.refreshToken
      }));
      dispatch(iniciarSesion(resp));
      navigate("/home/inicio", { replace: true });
    }
  };
  return (
    <div
      className="flex min-h-screen items-center justify-center bg-[#080892] p-4"
      style={{
        backgroundImage: `url(${fondo})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="w-full max-w-md rounded-xl bg-white/10 p-8 shadow-2xl backdrop-blur-lg">
        <img alt="pattern" src="/images/logoAXA.png" />

        <form>
          <div className="relative mb-4">
            {FaRegUser({
              className:
                "absolute left-4 top-1/2 -translate-y-1/2 text-white/60",
            })}
            <input
              type="text"
              placeholder="Usuario"
              name="username"
              value={username}
              onChange={handleInputChange}
              className="w-full rounded-lg border border-white/30 bg-white/10 py-3 pl-12 pr-4 text-white placeholder-white/70 transition-all focus:outline-none focus:ring-2 focus:ring-[#ff1e27]"
            />
          </div>

          {!IsPin && (
            <div className="relative mb-4">
              {FaRegEyeSlash({
                className:
                  "absolute left-4 top-1/2 -translate-y-1/2 text-white/60",
              })}
              <input
                type="password"
                placeholder="Contraseña"
                name="password"
                value={password}
                onChange={handleInputChange}
                className="w-full rounded-lg border border-white/30 bg-white/10 py-3 pl-12 pr-4 text-white placeholder-white/70 transition-all focus:outline-none focus:ring-2 focus:ring-[#ff1e27]"
              />
            </div>
          )}
          {IsPin && (
            <>
              <div className="relative my-4 text-center">
                <label className="w-full text-center text-white">
                  Te mandamos un NIP a tu cuenta de correo
                </label>
              </div>
              <div
                className="flex items-center justify-center space-x-3"
                onPaste={handlePaste}
              >
                {pin.map((digit, index) => (
                  <input
                    key={index}
                    ref={(el) => (inputRefs.current[index] = el)}
                    type="tel" // Usar 'tel' para mostrar el teclado numérico en móviles
                    maxLength={1}
                    value={digit}
                    onChange={(e) => handleChange(e, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    className="h-14 w-14 rounded-lg border border-white/30 bg-white/10 text-center text-2xl font-bold text-white
                     transition focus:outline-none focus:ring-2 focus:ring-[#ff1e27]"
                  />
                ))}
              </div>
            </>
          )}

          {isLoading && (
            <div className="flex w-full justify-center">
              <Spinner />
            </div>
          )}

          {!isLoading && (
            <button
              className="duration-300 mt-5 w-full rounded-lg bg-gradient-to-r from-[#ff1e27] to-[#fa5258] py-3 font-bold text-white shadow-lg transition-all hover:from-[#fa5258] hover:to-[#ff1e27]"
              onClick={handleLogin}
            >
              Iniciar Sesión
            </button>
          )}
        </form>
      </div>
    </div>
  );
};
